import qs from 'qs';
import React, { useEffect, useMemo, useState, type JSX } from 'react';
import { useDispatch } from 'react-redux';

import { actions as userActions } from '@/api/users';

import { AnchorButton } from '@payaca/ambrosia';
import MiniLoader from '@payaca/components/miniLoader/MiniLoader';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import BasicPageWrapper from '../pageWrappers/basicPageWrapper/BasicPageWrapper';
import './EnableCustomerPaymentsPage.sass';

const EnableCustomerPaymentsPage: React.FunctionComponent =
  (): JSX.Element | null => {
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useHistory();
    const [isProcessing, setIsProcessing] = useState(true);

    const [hasConnectionError, setHasConnectionError] = useState(false);

    const query = useMemo(() => {
      return qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });
    }, [location]);

    useEffect(() => {
      if (query.code) {
        dispatch(
          userActions.connectWithStripe(query.code, (error: any) => {
            if (!error) {
              history.push(
                '/companySettings/integrations-data/connections?isStripeConnectionSuccessRedirect=true'
              );
            } else {
              setIsProcessing(false);
              setHasConnectionError(true);
            }
          })
        );
      }
      // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has missing dependencies: 'dispatch', and 'history'
    }, [query.code]);

    useEffect(() => {
      if (query.error === 'access_denied') {
        // The user clicked 'return to Payaca' instead of proceeding with their stripe connection.
        // Do nothing, redirect to connections page.
        history.push('/companySettings/integrations-data/connections');
      } else if (query.error) {
        setHasConnectionError(true);
        setIsProcessing(false);
      }
      // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'history'
    }, [query.error]);

    return (
      <BasicPageWrapper className={'enable-customer-payments-page'}>
        {isProcessing && <MiniLoader />}
        {!isProcessing && (
          <>
            {hasConnectionError && (
              <h3>Something went wrong setting up your stripe connection</h3>
            )}
            <AnchorButton
              as={Link}
              to="/companySettings/integrations-data/connections"
            >
              Go to connections page
            </AnchorButton>
          </>
        )}
      </BasicPageWrapper>
    );
  };

export default EnableCustomerPaymentsPage;
